module.exports = __webpack_public_path__ + "img/favouritePiece.c4e906c.jpg";